export default __webpack_public_path__ + "static/Specialized_User_Service_Unit-452b11bcf7dcbf221dcc5366f31f45c7.pdf";